import React from "react";
import PropTypes from "prop-types";

import { useTranslation } from "next-i18next";
import Image from "next/image";

function AdvantagesSection({ advantages }) {
  const [t] = useTranslation();

  return (
    <section className="club-advantage club-page--background">
      <div className="club-advantage__wrapper">
        <div className="container">
          <h3 className="club-advantage__title club-page-title">
            {t("our_advantages")}
          </h3>

          <div className="club-advantage__inner">
            {advantages.map(({ id, title, image, description }) => (
              <div className="club-advantage__item" key={id}>
                <div className="club-advantage__title-block">
                  <div className="club-advantage__icon-wrapper">
                    {image && (
                      <Image
                        className="club-advantage__icon"
                        src={image}
                        alt={title}
                        
                        height={50}
                        width={50}
                        quality={"100"}
                      />
                    )}
                  </div>

                  <h3 className="club-advantage__title">{title}</h3>
                </div>

                <p className="club-advantage__description">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style jsx global>{`
        @import "./AdvantagesSection.scss?7";
      `}</style>
    </section>
  );
}

AdvantagesSection.propTypes = {
  advantages: PropTypes.array,
};

AdvantagesSection.defaultProps = {
  advantages: [],
};

export default AdvantagesSection;
